import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import {
	FormGroup,
	FormControl,
	FormLabel,
	Row,
	Col,
	FormCheck,
} from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import moment from "moment";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { getFirstLastInterval } from "utils/datetime";
import * as shiftsActions from "actions/shiftsActions";
import * as workflowsActions from "actions/workflowsActions";
import * as employeesActions from "actions/employeesActions";
import { workflowsService } from "services";
import { wfType, wfStatus } from "services/workflowsService";
import { isAdmin, isSupervisor } from "utils/utils";

class PreferenceEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		const requester_id = props.user.id;

		let preference = {
			//workflow_type_id: 2, // Preferencias
			type: wfType.preferences,
			shift_id: "",
			status: wfStatus.pending,
			start: moment().format("YYYY-MM-DD"),
			end: null,
			requester_id,
			isSingleDay: true,
			attachments: [],
			workflow_hourly_requested: false,
		};

		let isEdit = false;

		if (props.preference) {
			isEdit = true;
			preference = props.preference;
		}

		this.state = {
			isEdit,
			disabled: props.disabled ? true : false,
			isLoading: false,
			submitted: false,
			errors: {},
			preference,
		};
	}

	componentDidMount() {
		const { attendance_shifts, getAttendanceShifts } = this.props;

		if (!attendance_shifts || attendance_shifts.length === 0) {
			getAttendanceShifts();
		}
	}

	handleChange = (event) => {
		const { preference } = this.state;

		this.setState({
			preference: {
				...preference,
				[event.target.id]: event.target.value,
			},
		});
	};

	handleSwitch = (event) => {
		const { preference } = this.state;

		this.setState({
			preference: {
				...preference,
				[event.target.id]: event.target.checked,
			},
		});
	};

	handleDateChange = (id, date) => {
		const { preference } = this.state;

		let key = id;
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			preference: {
				...preference,
				[key]: value,
			},
		});
	};

	handlePeriodChange = (event) => {
		const { preference } = this.state;

		let key = event.target.id;
		let value = event.target.value;

		// console.log(key);
		// console.log(value);

		if (event.target.id === "single" || event.target.id === "multi") {
			key = "isSingleDay";
			value = event.target.id === "single";

			this.setState({
				preference: {
					...preference,
					[key]: value,
				},
			});
		} else {
			this.setState({
				preference: {
					...preference,
					isSingleDay: false,
				},
			});
		}
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = "";
		const props = this.props;
		const { preference } = this.state;
		var hasErrors = false;
		var errorMsg = "";

		//console.log(preference);

		// prepare workflow
		if (preference.isSingleDay) preference.end = null;

		if (
			preference.workflow_hourly_requested &&
			preference.start &&
			preference.start_hour
		) {
			const start_day = new Date(preference.start);
			const start_time = new Date(preference.start_hour);

			let start_frankenstein = new Date(
				start_day.getFullYear(),
				start_day.getMonth(),
				start_day.getDate(),
				start_time.getHours(),
				start_time.getMinutes()
			);

			const momentValue = moment.utc(start_frankenstein);
			start_frankenstein = momentValue.format();

			// console.log(start_frankenstein);
			preference.start_hour = start_frankenstein;
		}

		if (preference.duration)
			preference.duration = Number(normalizeDecimal(preference.duration));

		// update workflow
		if (this.state.isEdit) {
			response = await workflowsService.update(preference);
		} else {
			response = await workflowsService.add(preference);
		}

		if (!response.ok) {
			hasErrors = true;
			errorMsg = errorFormating(response);
		}

		//console.log(response);

		if (!hasErrors) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
					props.getEmployeePreferences(props.user.id);
					props.handleClose();

					if (isAdmin() || isSupervisor()) {
						this.props.getPendingPreferences();
						this.props.getManagedPreferences();
					}
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorMsg,
			});
		}
	};

	getSingleDayContent = () => {
		const { preference, disabled } = this.state;
		return (
			<FormGroup
				controlId="start"
				className={`form-group form-date flex-col ${preference.start === "" && "empty"} ${this.checkValidField("start") && "is-invalid"}`}
			>
				<FormLabel>
					{this.props.t("preferences.modal.requestedDate")} <span className="label-required">*</span>
				</FormLabel>

				<DatePicker
					selected={
						preference.start === "" || !preference.start
							? preference.start
							: moment(preference.start).toDate()
					}
					onChange={(date) => this.handleDateChange("start", date)}
					isInvalid={this.checkValidField("start")}
					className="form-control"
					dateFormat="dd/MM/yyyy"
					locale="es"
					placeholderText="dd/mm/aaaa"
					disabled={disabled}
				/>
				<FiCalendar />
				<FormControl.Feedback type="invalid">
					{this.state.errors.start}
				</FormControl.Feedback>
			</FormGroup>
		);
	};

	getStartEndContent = () => {
		const { preference, disabled } = this.state;
		// console.log(preference.start);
		// console.log(preference.end);
		return (
			<Row>
				<Col sm={6}>
					<FormGroup
						controlId="start"
						className={`form-group form-date ${preference.start === "" && "empty"}  ${this.checkValidField("start") && "is-invalid"}`}
					>
						<FormLabel>
							{this.props.t("preferences.modal.starts")} <span className="label-required">*</span>
						</FormLabel>
						<DatePicker
							selected={
								preference.start === "" || !preference.start
									? preference.start
									: moment(preference.start).toDate()
							}
							onChange={(date) => this.handleDateChange("start", date)}
							isInvalid={this.checkValidField("start")}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							locale="es"
							placeholderText="dd/mm/aaaa"
							disabled={disabled}
						/>
						<FiCalendar />
						<FormControl.Feedback type="invalid">
							{this.state.errors.start}
						</FormControl.Feedback>
					</FormGroup>
				</Col>

				<Col sm={6}>
					<FormGroup
						controlId="end"
						className={`form-group form-date ${preference.end === "" && "empty"}  ${this.checkValidField("end") && "is-invalid"}`}
					>
						<FormLabel>
							{this.props.t("preferences.modal.ends")} <span className="label-required">*</span>
						</FormLabel>
						<DatePicker
							selected={
								preference.end === "" || !preference.end
									? preference.end
									: moment(preference.end).toDate()
							}
							onChange={(date) => this.handleDateChange("end", date)}
							isInvalid={this.checkValidField("end")}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							locale="es"
							placeholderText="dd/mm/aaaa"
							disabled={disabled}
						/>
						<FiCalendar />
						<FormControl.Feedback type="invalid">
							{this.state.errors.end}
						</FormControl.Feedback>
					</FormGroup>
				</Col>
			</Row>
		);
	};

	render() {
		const { preference, errors, disabled } = this.state;

		const { attendance_shifts = [] } = this.props;
		const optionShiftList =
			attendance_shifts.length > 0 &&
			attendance_shifts.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name} {getFirstLastInterval(item.time_intervals, true)}
					</option>
				);
			}, this);

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body shift-edit">
					<div className="alert alert-info">
						<Trans
							i18nKey="preferences.modal.infoText"
							components={{ bold: <strong /> }}
						/>
					</div>
					<FormGroup controlId="period" className="form-group mt25">
						<FormLabel className="hidden">{this.props.t("preferences.modal.duration")}</FormLabel>
						<div className="btn-choice-group">
							<FormCheck
								type="radio"
								id="single"
								label={this.props.t("preferences.modal.singleDay")}
								value="false"
								checked={preference.isSingleDay}
								bsPrefix={
									preference.isSingleDay ? "btn-choice active" : "btn-choice"
								}
								onChange={this.handlePeriodChange}
								disabled={disabled}
							/>
							<FormCheck
								type="radio"
								id="multi"
								label={this.props.t("preferences.modal.multiDay")}
								value="false"
								checked={!preference.isSingleDay}
								bsPrefix={
									!preference.isSingleDay ? "btn-choice active" : "btn-choice"
								}
								onChange={this.handlePeriodChange}
								disabled={disabled}
							/>
						</div>
					</FormGroup>

					{preference.isSingleDay
						? this.getSingleDayContent()
						: this.getStartEndContent()}

					<FormGroup className="form-group" controlId="shift_id">
						<FormLabel>
							{this.props.t("preferences.modal.desiredShift")} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="text"
							value={preference.shift_id}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("shift_id")}
							as="select"
							disabled={disabled}
						>
							<option value="">{this.props.t("preferences.modal.selectShift")}</option>
							{optionShiftList}
						</FormControl>
						<FormControl.Feedback type="invalid">
							{errors.shift_id}
						</FormControl.Feedback>
					</FormGroup>

					{errors && errors.general && (
						<div className="alert alert-danger alert-general-error fade show" role="alert">
							{errors.general}
						</div>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t("common.cancel")}
					</button>
					{!disabled && (
						<SubmitButton
							type="submit"
							isLoading={this.state.isLoading}
							text={this.props.t("common.save")}
							loadingText={this.props.t("common.saving")}
						/>
					)}
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getEmployeePreferences: (employee_id) =>
		dispatch(employeesActions.getEmployeePreferences(employee_id)),
	getPendingPreferences: (options) =>
		dispatch(workflowsActions.getPendingPreferences(options)),
	getManagedPreferences: (options) =>
		dispatch(workflowsActions.getManagedPreferences(options)),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PreferenceEdit));
